<div class="classic-page-container">
  <main id="main" class="container site-main">
    <div class="site-content">
      <div class="errorpage">
        <header>
          <h1>{{ 'fspro.front.error.playback.title' | translate }}</h1>
        </header>
        <section>
          <p [innerHtml]="'fspro.front.error.playback.message' | translate: { contactus: contactUs }"></p>
        </section>
      </div>
    </div>
  </main>
</div>
